/**
 * SEO component that queries for data with
 * Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/how-to/querying-data/use-static-query/
 */

import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { useLocation } from "@reach/router"

const OG_IMAGE = "/opengraph.jpg"

function constructUrl(baseUrl, path) {
  if (baseUrl === "" || path === "") return ""
  return `${baseUrl}${path}`
}

function Seo({ title, description, image, children }) {
  const {
    site: { defaultMeta },
  } = useStaticQuery(
    graphql`
      query {
        site {
          defaultMeta: siteMetadata {
            title
            description
            siteUrl
          }
        }
      }
    `
  )
  const location = useLocation()
  const siteUrl = defaultMeta?.siteUrl.replace(/\/$/, "")
  let pageUrl = constructUrl(siteUrl, location.pathname)

  const defaultTitle = defaultMeta?.title
  const metaTitle =
    title && description
      ? title
      : title
      ? `${defaultTitle} | ${title}`
      : defaultTitle
  const metaDescription = description || defaultMeta.description
  const metaImage = constructUrl(siteUrl, image ?? OG_IMAGE)

  return (
    <>
      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription} />

      <meta property="og:site_name" content={defaultTitle} />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={metaImage} />
      <meta property="og:image:alt" content={defaultTitle} />
      <meta property="og:url" content={pageUrl} />

      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta property="twitter:image" content={metaImage} />
      <meta property="twitter:image:alt" content={defaultTitle} />
      <meta name="twitter:url" content={pageUrl} />

      <meta itemProp="name" content={metaTitle} />
      <meta itemProp="description" content={metaDescription} />
      <meta itemProp="url" content={pageUrl} />

      <link rel="canonical" href={pageUrl} />

      {children}
    </>
  )
}

export default Seo
